import { HttpClient } from '@angular/common/http';
import { ConfigService } from './services/config.service';

export default { load };

function load(http: HttpClient, config: ConfigService): (() => Promise<boolean>) {
  return (): Promise<boolean> => {
    return new Promise<boolean>((resolve: (a: boolean) => void): void => {
      http.get('assets/config/config.json').toPromise()
        .then((result: { backend: { host: string, port: string, protocol: string } }) => {
          config.API_URL = `${result.backend.protocol}://${result.backend.host}:${result.backend.port}/api`;
          config.PUB_URL = `${result.backend.protocol}://${result.backend.host}:${result.backend.port}/api`;
          resolve(true);
        })
        .catch(error => {
          config.API_URL = 'https://apim.saesa.cl/api';
          config.PUB_URL = 'https://apim.saesa.cl/api';
          resolve(true);
        });
    });
  };
}
